"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../_abstract/adapter");
const Embed_contracts_1 = require("./Embed.contracts");
const EmbedIframe_adapter_1 = require("./versions/iframe/EmbedIframe.adapter");
const EmbedPdf_adapter_1 = require("./versions/pdf/EmbedPdf.adapter");
const EmbedYouTube_adapter_1 = require("./versions/youtube/EmbedYouTube.adapter");
const EmbedTwitter_adapter_1 = require("./versions/twitter/EmbedTwitter.adapter");
const EmbedVideo_adapter_1 = require("./versions/video/EmbedVideo.adapter");
const EmbedVideoSwitch_adapter_1 = require("./versions/videoSwitch/EmbedVideoSwitch.adapter");
/**
 * Registry that binds the `TokenType` with the applicable adapter.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const tokenTypeAdapterRegistry = {
    [demarked_1.TokenType.Embed]: new EmbedIframe_adapter_1.EmbedIframeAdapter(),
    [demarked_1.TokenType.EmbedPdf]: new EmbedPdf_adapter_1.EmbedPdfAdapter(),
    [demarked_1.TokenType.EmbedTwitter]: new EmbedTwitter_adapter_1.EmbedTwitterAdapter(),
    [demarked_1.TokenType.EmbedYouTube]: new EmbedYouTube_adapter_1.EmbedYouTubeAdapter(),
    [demarked_1.TokenType.EmbedVideo]: new EmbedVideo_adapter_1.EmbedVideoAdapter(),
    [demarked_1.TokenType.EmbedVideoSwitch]: new EmbedVideoSwitch_adapter_1.EmbedVideoSwitchAdapter()
};
/**
 * Registry that binds the `TokenType` with the applicable adapter.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
const embedVersionAdapterRegistry = {
    [Embed_contracts_1.EmbedVersion.Iframe]: new EmbedIframe_adapter_1.EmbedIframeAdapter(),
    [Embed_contracts_1.EmbedVersion.PDF]: new EmbedPdf_adapter_1.EmbedPdfAdapter(),
    [Embed_contracts_1.EmbedVersion.Twitter]: new EmbedTwitter_adapter_1.EmbedTwitterAdapter(),
    [Embed_contracts_1.EmbedVersion.YouTube]: new EmbedYouTube_adapter_1.EmbedYouTubeAdapter(),
    [Embed_contracts_1.EmbedVersion.Video]: new EmbedVideo_adapter_1.EmbedVideoAdapter(),
    [Embed_contracts_1.EmbedVersion.VideoSwitch]: new EmbedVideoSwitch_adapter_1.EmbedVideoSwitchAdapter()
};
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
class EmbedAdapter extends adapter_1.AbstractAdapter {
    /**
     * Adapts (translates/maps) the passed-in `EmbedModule` to the `EmbedToken` or `EmbedYouTubeToken`.
     *
     * @param object - The module to adapt.
     * @param storage
     */
    objectToToken(object, storage) {
        if (!(object.version in embedVersionAdapterRegistry)) {
            throw new Error(`EmbedAdapter.objectToToken(): There's no applicable adapter for the object with of given driver!\nFull [object] object: ${JSON.stringify(object)}`);
        }
        return embedVersionAdapterRegistry[object.version].objectToToken(object, storage);
    }
    /**
     * Adapts (translates/maps) the passed-in `EmbedToken` or `EmbedYouTubeToken` to the `EmbedModule`.
     *
     * @param token - The token to adapt.
     * @param storage
     */
    tokenToObject(token, storage) {
        if (!(token.type in tokenTypeAdapterRegistry)) {
            throw new Error(`EmbedAdapter.tokenToObject(): There's no applicable adapter for the token with of given type!\nFull [token] object: ${JSON.stringify(token)}`);
        }
        return tokenTypeAdapterRegistry[token.type].tokenToObject(token, storage);
    }
}
exports.EmbedAdapter = EmbedAdapter;
//# sourceMappingURL=Embed.adapter.js.map